import { getRequest } from '../api-handler';
import { ProductTypeDetailDto } from './producttype';

export const ProductTypeApi = {
  getById: (id: number) =>
    getRequest<ProductTypeDetailDto>(`/producttypes/${id}`)
};
